const { compose, join, map, prop, propOr } = require('ramda');
module.exports = compose(join(', '), map(prop('name')), propOr([], 'users'));
